import { PlanogramProductDetailSchema } from "@labeling-tools/api/atlas/types.gen";
import { mvpApiCreateProductIssueMutation } from "@labeling-tools/api/atlas/@tanstack/react-query.gen";
import { useMutation } from "@tanstack/react-query";
import { Loader } from "@mantine/core";
import { Button } from "@mantine/core";
import { useState, useCallback, useEffect } from "react";
import { toast } from "sonner";
import { formatMoney } from "./utils/helpers";

// TODO clean up task, handleCopyId should be a util probably
const handleCopyId = (id: string) => {
  navigator.clipboard.writeText(id);
};

export const PlanogramProduct = ({
  selectedProduct,
  enable_product_id_copy,
  loading,
}: {
  selectedProduct?: PlanogramProductDetailSchema;
  enable_product_id_copy?: boolean;
  loading?: boolean;
}) => {
  const [popoverImageLoaded, setPopoverImageLoaded] = useState(false);
  const handlePopoverImageLoad = useCallback(
    () => setPopoverImageLoaded(true),
    [],
  );

  const {
    mutate: reportBadImage,
    isPending: isReporting,
    isSuccess: isReported,
    isError: isReportError,
  } = useMutation(mvpApiCreateProductIssueMutation());

  useEffect(() => {
    if (isReportError) {
      toast.error("Failed to report bad image. Please try again.");
    }
  }, [isReportError]);

  return (
    <div className="p-4 max-w-[400px]">
      {selectedProduct ? (
        <>
          <div className="flex justify-center">
            <div className="size-36 bg-white relative">
              {!!selectedProduct?.image_url && (
                <>
                  {!popoverImageLoaded && (
                    <div className="absolute inset-0 flex items-center justify-center">
                      <Loader size="sm" />
                    </div>
                  )}
                  <img
                    src={selectedProduct?.image_url}
                    className={`size-full object-contain ${!popoverImageLoaded ? "opacity-0" : ""}`}
                    onLoad={handlePopoverImageLoad}
                  />
                </>
              )}
            </div>
          </div>

          <div className="h-4" />

          <div className="space-y-2 text-xs text-center">
            {!!selectedProduct?.description && (
              <div className="font-semibold">
                {selectedProduct?.description}
              </div>
            )}
            <div className="text-gray-500">
              Facings: {selectedProduct.facings ?? 0}
            </div>
            {selectedProduct.price != null && (
              <div className="text-gray-500">
                Price: {formatMoney(selectedProduct.price)}
              </div>
            )}
            {enable_product_id_copy === true && (
              <div className="mb-2">
                <Button onClick={() => handleCopyId(selectedProduct.id)}>
                  Copy to Clipboard
                </Button>
              </div>
            )}
            <div>
              <Button
                color="red"
                variant="transparent"
                size="xs"
                onClick={() =>
                  reportBadImage({
                    body: {
                      type: "bad_image",
                      planogram_product_id: selectedProduct.id,
                      product_id: selectedProduct.product_id,
                    },
                  })
                }
                loading={isReporting}
                disabled={isReported}
              >
                {isReported
                  ? "Reported"
                  : isReportError
                    ? "Failed - Try Again"
                    : "Report Bad Image"}
              </Button>
            </div>
          </div>
        </>
      ) : loading ? (
        <div className="flex justify-center items-center h-full">
          <Loader />
        </div>
      ) : null}
    </div>
  );
};
